/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceFaqItem
 */
export interface SurfaceFaqItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceFaqItem
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceFaqItem
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceFaqItem
     */
    answer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceFaqItem
     */
    defaultOpen?: boolean;
}

/**
 * Check if a given object implements the SurfaceFaqItem interface.
 */
export function instanceOfSurfaceFaqItem(value: object): value is SurfaceFaqItem {
    return true;
}

export function SurfaceFaqItemFromJSON(json: any): SurfaceFaqItem {
    return SurfaceFaqItemFromJSONTyped(json, false);
}

export function SurfaceFaqItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceFaqItem {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'question': json['question'] == null ? undefined : json['question'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'defaultOpen': json['defaultOpen'] == null ? undefined : json['defaultOpen'],
    };
}

export function SurfaceFaqItemToJSON(json: any): SurfaceFaqItem {
    return SurfaceFaqItemToJSONTyped(json, false);
}

export function SurfaceFaqItemToJSONTyped(value?: SurfaceFaqItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'question': value['question'],
        'answer': value['answer'],
        'defaultOpen': value['defaultOpen'],
    };
}

